module.exports = "pegasus_template/assets/themelp1/product/109.png";